import React from 'react';
import { format } from 'date-fns';
import { AUIButtonCell } from '@ancert/aui-table-cell';
import AUIEllipsis from '@ancert/aui-ellipsis';

const getColumns = (desasignarDenuncia) => [
  {
    id: 'usuario',
    accessor: (row) => row.user.name,
    header: 'Usuario',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'documentType',
    accessor: (row) => row.user.documentType,
    columnWidth: 120,
    header: 'Tipo documento',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'dni',
    accessor: (row) => row.user.document,
    columnWidth: 100,
    header: 'Doc. identidad',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'email',
    accessor: (row) => row.user.email,
    columnWidth: 384,
    header: 'Correo electrónico',
    cell: ({ value }) => <AUIEllipsis content={value ?? ''}/>,
  },
  {
    id: 'fecha',
    accessor: (row) => row.user.creationDate,
    header: 'Fecha',
    columnWidth: 96,
    cell: ({ value }) => <>{format(new Date(value), 'dd/MM/yyyy')}</>,
  },
  {
    id: 'status',
    accessor: (row) => row.user.active,
    header: 'Estado',
    columnWidth: 64,
    cell: ({ value }) => <>{value ? 'Activo' : 'Inactivo'}</>,
  },
  {
    id: 'action',
    columnWidth: 80,
    accessor: (row) => row.user.id,
    header: '',
    cell: ({ value }) => (
      <AUIButtonCell
        buttonList={[
          {
            mode: 'ghost',
            label: 'Desasignar',
            onClick: () => {
              desasignarDenuncia(value);
            },
          },
        ]}
      />
    ),
  },
];

export default getColumns;
